const HR = () => {
	return <div className="relative z-20 h-1 bg-gradient-to-r from-white/0  via-white/70 to-white/0" />
}

export default HR
